export default function CBitwiseOperators() {
  return <h2>C Bitwise Operators</h2>;
}
